import { createContext, useContext } from 'react';

// Lets any button on the page jump to the interest form with a role chosen.
// The provider is InterestProvider in ui.jsx.
export const InterestContext = createContext({
	role: 'shop',
	setRole: () => {},
	openInterest: () => {},
});

export const useInterest = () => useContext(InterestContext);
